import useReportsPage from "./hooks/useReportsPage";
import Page from "../../components/Page";

const ReportsPage = () => {
  const page = useReportsPage();

  return <Page {...page} />;
};

export default ReportsPage;
